import addDays from "date-fns/addDays";
import { endOfDay } from "date-fns";

export default (start: Date, length: number) => ({
  start,
  end: endOfDay(addDays(start, length - 1)),
  duration: length
});
